import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import ReactGA from 'react-ga'
import { hotjar } from 'react-hotjar'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faKey, faMobileAlt } from '@fortawesome/free-solid-svg-icons'
import {
  GROUP,
  INDEX,
  LOGIN,
  OVERVIEW,
  SETTINGS_EDIT_MAMORIO,
  SETTINGS_EVENT_TRIGGERS,
  SETTINGS_GROUP_MANAGEMENT,
  SETTINGS_MAMORIO_SPOT,
  SETTINGS_GROUP_MANAGEMENT_USERS,
  UNAUTHORIZED,
  USER_SETTING,
  VERIFICATION,
  NEWS,
  MAMORIOS_DETAIL,
  GPS_TRACKERS_DETAIL,
  HEATMAP,
  QR_TAG_EVENT_RECORDER,
  GROUP_QR_PRINT,
  SETTINGS_QR_TAGS,
  SETTINGS_BIZ_ACCESS_LOGS,
  SETTINGS_BIZ_ACCESS_LOGS_DETAIL,
} from './constants/Paths'
import RequireAuth from './components/auth/RequireAuth'
import Login from './containers/Login/Login'
import Verification from './containers/Verification'
import Unauthorized from './containers/Unauthorized'
import Overview from './containers/Overview'
import User from './containers/User'
import SettingsEditMamorio from './components/settings/mamorio/SettingsEditMamorio'
import SettingsGroupManagement from './components/settings/group/SettingsGroupManagement'
import SettingsGroupManagementUsers from './components/settings/group/SettingsGroupManagement/SettingsGroupManagementUsers'
import SettingsMamorioSpot from './components/settings/SettingsMamorioSpot'
import SettingsEventTriggers from './components/settings/EventTriggers'
import RootModal from './components/common/RootModal'
import NewsPage from './components/news/news'

import type { RootState } from './store'
import BizPlusPage from './components/biz_plus/biz_plus'
import MamorioDetailPage from './components/overview/MamorioDetailPage'
import GpsTrackerDetailPage from './components/overview/GpsTrackerDetailPage'
import QrTagEventRecorderPage from './containers/QrTagEventRecorder/QrTagEventRecorder'
import GroupQrPrintPage from './containers/GroupQrPrint'
import SettingsQrTags from './components/settings/qr_tags/SettingsQrTags'
import SettingsBizAccessLogs from './components/settings/biz_access_logs/SettingsBizAccessLogs'
import SettingsBizAccessLogDetail from './components/settings/biz_access_logs/SettingsBizAccessLogDetail'

library.add(faKey, faMobileAlt)

export default () => {
  const currentUser = useSelector((state: RootState) => state.user.user)
  const team = useSelector((state: RootState) => state.team)
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    if (isInitialized) return

    ReactGA.initialize('UA-33978950-20')
    ReactGA.pageview(window.location.pathname)
    hotjar.initialize(862615, 6)

    setIsInitialized(true)
  }, [isInitialized])

  return (
    <React.StrictMode>
      <BrowserRouter>
        <Switch>
          <Route path={LOGIN}>
            <Login />
          </Route>
          <Route path={VERIFICATION}>
            <Verification />
          </Route>
          <Route path={UNAUTHORIZED}>
            <Unauthorized />
          </Route>
          <Route
            exact
            path={INDEX}
            render={() => (
              <RequireAuth>
                <SettingsEditMamorio showTabs={false} showEditButton={false} />
              </RequireAuth>
            )}
          />
          <Route
            exact
            path={OVERVIEW}
            render={() => (
              <RequireAuth>
                {
                  team.biz_plus === true
                    ? <BizPlusPage />
                    : <SettingsEditMamorio showTabs={false} showEditButton={false} />
                }
              </RequireAuth>
            )}
          />
          <Route
            path={USER_SETTING}
            render={() => (
              <RequireAuth>
                <User />
              </RequireAuth>
            )}
          />
          <Route
            exact
            path={GROUP}
            render={() => (
              <RequireAuth>
                {
                  team.biz_plus === true
                    ? <BizPlusPage />
                    : <Overview />
                }
              </RequireAuth>
            )}
          />
          <Route
            exact
            path={NEWS}
            render={() => (
              <RequireAuth>
                <NewsPage />
              </RequireAuth>
            )}
          />
          <Route
            exact
            path={HEATMAP}
            render={() => (
              <RequireAuth>
                <BizPlusPage />
              </RequireAuth>
            )}
          />
          <Route
            exact
            path={GPS_TRACKERS_DETAIL}
            render={() => (
              <RequireAuth>
                <GpsTrackerDetailPage />
              </RequireAuth>
            )}
          />
          {
            currentUser && (
              <>
                <Route
                  path={SETTINGS_EDIT_MAMORIO}
                  render={() => (
                    <RequireAuth>
                      <SettingsEditMamorio />
                    </RequireAuth>
                  )}
                />
                <Route
                  path={SETTINGS_GROUP_MANAGEMENT_USERS}
                  render={() => (
                    <RequireAuth>
                      <SettingsGroupManagementUsers />
                    </RequireAuth>
                  )}
                />
                <Route
                  exact
                  path={SETTINGS_GROUP_MANAGEMENT}
                  render={() => (
                    <RequireAuth>
                      <SettingsGroupManagement />
                    </RequireAuth>
                  )}
                />
                <Route
                  path={MAMORIOS_DETAIL}
                  render={() => (
                    <MamorioDetailPage />
                  )}
                />
                <Route
                  path={SETTINGS_MAMORIO_SPOT}
                  render={() => (
                    <RequireAuth>
                      <SettingsMamorioSpot />
                    </RequireAuth>
                  )}
                />
                <Route
                  path={SETTINGS_EVENT_TRIGGERS}
                  render={() => (
                    <RequireAuth>
                      <SettingsEventTriggers />
                    </RequireAuth>
                  )}
                />
                <Route
                  path={SETTINGS_QR_TAGS}
                  render={() => (
                    <RequireAuth>
                      <SettingsQrTags />
                    </RequireAuth>
                  )}
                />
                <Route
                  path={SETTINGS_BIZ_ACCESS_LOGS_DETAIL}
                  render={() => (
                    <RequireAuth>
                      <SettingsBizAccessLogDetail />
                    </RequireAuth>
                  )}
                />
                <Route
                  exact
                  path={SETTINGS_BIZ_ACCESS_LOGS}
                  render={() => (
                    <RequireAuth>
                      <SettingsBizAccessLogs />
                    </RequireAuth>
                  )}
                />
                <Route
                  exact
                  path={QR_TAG_EVENT_RECORDER}
                  render={() => (
                    <RequireAuth>
                      <QrTagEventRecorderPage />
                    </RequireAuth>
                  )}
                />
                <Route
                  exact
                  path={GROUP_QR_PRINT}
                  render={() => (
                    <RequireAuth>
                      <GroupQrPrintPage />
                    </RequireAuth>
                  )}
                />
              </>
            )
          }
        </Switch>
      </BrowserRouter>
      <RootModal />
    </React.StrictMode>
  )
}
